import { compose, filter, path, whereEq } from 'ramda'

export default (getItems, filterObj) =>
  compose(
    path([0]),
    filter(whereEq(filterObj)),
    getItems
  )
